// Formata uma data em ISO para o formato dd/mm/aaaa
export const formatISODate = (date) => {
  const formattedDate = new Date(date);

  return formattedDate.toLocaleDateString('pt-br');
};

// Formata datas 'aaaa-mm-dd' para 'dd/mm/aaaa'
export const formatDataString = (str) => {
  const date = str.split('-').reverse().join('/');

  return date;
};
